import { useContext, useState, useEffect } from "react";
import { Context } from "../context/DataContext";
import useCustomerBlock from "@shared/hooks/useCustomerBlock";
import RenderDisabledCustomer from "@shared/components/RenderDisabledCustomer";
import SearchBox from "@shared/components/common/SearchBox";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
// import { Link } from "react-router-dom";
import { getGastosSelector } from "../context/Selectors";
import { printAmount, newDate, printDate, RemoveAccents } from "@shared/functions";
import CreateSpense from "../components/CreateSpense";
import DateRangePicker from "@shared/components/DateRangePicker";
import DeleteGastoModal from "../components/DeleteGastoModal";
import { UseGastos, UseRoute, UseVerificationGastos } from "@shared/server/fetcher";
import Loading from "@shared/components/Loading";
import { useSWRConfig } from "swr";

const Spenses = () => {
  const { mutate } = useSWRConfig();
  const { state, createGasto, deleteGasto } = useContext(Context);
  const [searchText, setSearchText] = useState("");
  const [currentData, setCurrentData] = useState({ amount: 0, count: 0, list: [] });
  const { user, route: stateRoute } = state;
  const [currentDates, setCurrentDates] = useState(null);

  const { data: route, isLoading: routeLoading } = UseRoute(stateRoute.creditor_id, user.user_id);
  const block = useCustomerBlock(stateRoute?.user_id);
  const {
    data: gastos,
    isLoading,
    key,
  } = UseGastos(
    route?.creditor_id,
    currentDates?.start_date ?? route?.collect_week_date,
    currentDates?.end_date ?? route?.current_range_date
  );

  const { data: createdGastos, isLoading: gVer_loading } = UseVerificationGastos(route?.cuadre_id);

  useEffect(() => {
    if (route && !currentDates?.start_date) {
      setCurrentDates({
        start_date: route.collect_week_date,
        end_date: route.current_range_date,
      });
    }

    if (gastos) {
      setCurrentData(getGastosSelector(gastos));
    }
    //eslint-disable-next-line
  }, [route, gastos]);

  useEffect(() => {
    if (createdGastos?.length > 0) {
      mutate(key);
    }

    //eslint-disable-next-line
  }, [createdGastos]);

  if (isLoading || routeLoading || block.isChecking) return <Loading />;
  if (block.isBlocked) return <RenderDisabledCustomer {...block.disabledProps} />;

  const handleCreateGasto = async (data) => {
    await createGasto(data);
    mutate(key);
  };

  const handleDeleteGasto = async (data) => {
    await deleteGasto(data);
    mutate(key);
  };

  const getFilteredDebtor = (debtors) => {
    let filtered = debtors;

    if (searchText.length > 2) {
      filtered = filtered.filter(
        (m) => RemoveAccents(m.description).toUpperCase().indexOf(searchText.toUpperCase()) >= 0
      );
    }

    return filtered;
  };

  const loansFilter = getFilteredDebtor(gastos);

  const handleSearch = (query) => {
    setSearchText(query);
  };

  return (
    <>
      <CreateSpense
        handleCreateGasto={handleCreateGasto}
        creditor_id={route.creditor_id}
        date={route.today_date}
        user_id={user.user_id}
      />
      {currentData.count === 0 ? (
        <div className="container mt-4 mb-5">
          <Typography variant="h5" componet="h3" gutterBottom>
            Gastos Registrado!
          </Typography>
          <Typography variant="body1" componet="p" paragraph>
            En esta pagina puede ver todo los gastos registrado.
          </Typography>
          <Typography variant="body1" componet="p" paragraph>
            Por el momento, no ha ah registrado ningun gasto!
          </Typography>
          <DateRangePicker setCurrentDate={setCurrentDates} date={currentDates} route={route} />
        </div>
      ) : (
        <div className="mt-3">
          <Box component="div" p={1}>
            <Typography variant="h6" component="h4">
              Gastos ({currentData.count}):
              {printAmount(currentData.amount)}
            </Typography>
            <Typography variant="body1" component="h4">
              Lista de gastos para esta Semana
            </Typography>
            <DateRangePicker setCurrentDate={setCurrentDates} date={currentDates} route={route} />
            <SearchBox onChange={handleSearch} placeHolder="Escriba para buscar Gasto..." value={searchText} />
          </Box>

          <div className="mb-5">
            <table className="table table-sm">
              <thead>
                <tr>
                  <th scope="col">Gasto</th>
                  <th scope="col">Cantidad</th>
                  <th scope="col">Fecha</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {loansFilter.map((gasto) => (
                  <tr key={gasto.id}>
                    <td>
                      <Typography variant="subtitle2" component="p" className="font-weight-bold">
                        {/* <Link style={{ color: "#000" }} to={`/loan/detail/${gasto.money_id}`}> */}
                        {gasto.description}
                        {/* </Link> */}
                      </Typography>
                    </td>
                    <td>{printAmount(gasto.amount)}</td>
                    <td>{printDate(newDate(gasto.date))}</td>
                    <td>
                      <DeleteGastoModal handleDeleteGasto={handleDeleteGasto} gasto={gasto} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {/* <BottomNavigation history={history} /> */}
    </>
  );
};

export default Spenses;
